import { Emitter } from '@pixi/particle-emitter'
import { Dict } from '@pixi/utils'
import { AnimatedSprite, Container, DisplayObject, LoaderResource, Resource, Sprite, Texture } from 'pixi.js'
import { levels } from './systems/changeLevelSystem'
import { initLevelEditor } from './systems/levelEditor'

const spritePool = {
	container: new Container(),
	walrusMainBody: new Sprite(),
	walrusHead: null as AnimatedSprite | null,
	walrusMidBody: new Sprite(),
	walrusTail: new Sprite(),
	sprite: new Sprite(),
	debug: new Container(),
	debugSprites: [
		new Sprite(Texture.WHITE),
		new Sprite(Texture.WHITE),
		new Sprite(Texture.WHITE),
		new Sprite(Texture.WHITE),
		new Sprite(Texture.WHITE),
	],
	dustEmitter: null as Emitter | null,
	world: null as AnimatedSprite | null,
	obstacleSprites: {
		oar: [new Sprite()],
		// bench: new Sprite(),
		// benchAngled: new Sprite(),
		// boat: new Sprite(),
		// binoculars: new Sprite(),
		// binocularsSilhouet: new Sprite(),
		// bunker: new Sprite(),
		// dogSign: new Sprite(),
		// fenceWide: new Sprite(),
		// house: new Sprite(),
		// kaapsduinSign: new Sprite(),
		// natureSignPost: new Sprite(),
		// paaltje: new Sprite(),
		trunkHorizontal: [new Sprite()],
	} as Record<string, Sprite[]>,
}

export const initSpritePool = (resources: Dict<LoaderResource>, stage: Container<DisplayObject>) => {
	const { debug, container } = spritePool
	const worldAnimatedSpriteResources = levels
		.map(level => resources[`world${level}`].texture)
		.filter(henk => !!henk) as Texture<Resource>[]

	spritePool.world = new AnimatedSprite(worldAnimatedSpriteResources)
	spritePool.world.gotoAndStop(0)
	container.addChild(spritePool.world)

	initLevelEditor(resources)

	spritePool.walrusTail = new Sprite(resources.walrusBody3.texture)
	spritePool.walrusMidBody = new Sprite(resources.walrusBody2.texture)
	spritePool.walrusMainBody = new Sprite(resources.walrusBody1.texture)

	spritePool.walrusHead = new AnimatedSprite([
		resources.walrusHead1.texture ?? Texture.WHITE,
		resources.walrusHead2.texture ?? Texture.WHITE,
		resources.walrusHead3.texture ?? Texture.WHITE,
		resources.walrusHead4.texture ?? Texture.WHITE,
		resources.walrusHead5.texture ?? Texture.WHITE,
		resources.walrusHead6.texture ?? Texture.WHITE,
		resources.walrusHead7.texture ?? Texture.WHITE,
		resources.walrusHead8.texture ?? Texture.WHITE,
		resources.walrusHead9.texture ?? Texture.WHITE,
		resources.walrusHeadCharge1.texture ?? Texture.WHITE,
		resources.walrusHeadCharge2.texture ?? Texture.WHITE,
		resources.walrusHeadCharge3.texture ?? Texture.WHITE,
		resources.walrusHeadCharge4.texture ?? Texture.WHITE,
	])
	spritePool.walrusHead.animationSpeed = 0
	spritePool.walrusHead.onLoop = function () {
		this.gotoAndPlay(9)
	}
	spritePool.walrusTail.anchor.set(0.5, 0.5)
	spritePool.walrusMidBody.anchor.set(0.5, 0.5)
	spritePool.walrusMainBody.anchor.set(0.5, 0.5)
	spritePool.walrusHead.anchor.set(0.5, 0.5)

	container.addChild(spritePool.walrusTail)
	container.addChild(spritePool.walrusMidBody)
	container.addChild(spritePool.walrusMainBody)
	container.addChild(spritePool.walrusHead)
	if (container) stage.addChild(container)
	if (process.env.NODE_ENV !== 'production' && debug) container.addChild(debug)
}

export default spritePool
